// libraries.
import { Badge } from 'react-bootstrap';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// selector.
import { TaskItem } from '@domains/documents-review/interfaces/interfaces';
import { CountryCode } from '@domains/country';
import { getSelectedTask } from '@domains/documents-review/store/slices/document-review-slice';

// slice.
import { useGetTaskDetailQuery } from '@domains/documents-review/store/api-slices/task-detail.endpoints';
import { useGetLeadDetailInfoQuery } from '@domains/lead-detail';
import { setLeadDetailData } from '@domains/lead-detail/store/slices/lead-detail-slice';
import { leadDetailDataCO } from '@domains/lead-detail/utils/leadDetailData';

// components.
import { LoteIdWarning } from '@shared/LoteIdWarning/LoteIdWarning';
import { PriceAvailabilityBanner } from '@shared/PriceAvailabilityBanner/PriceAvailabilityBanner';

// hooks.
import { useGetNidPriceAvailabilityQuery } from '@domains/nid-price-availability';

const CUSTOM_FIELDS_FOR_SELLERS_CO =
  'agente_pricing,nombre_del_conjunto,torre,apartamento,tipo_de_garaje,numero_parqueaderos,calificacion_lead_remodelaciones,el_negocio_tiene_hijos_menores_';

export const DataSellersCO = () => {
  const dispatch = useDispatch();
  const detailTask = useSelector(getSelectedTask) as TaskItem;

  const { data, isFetching } = useGetTaskDetailQuery({
    country: CountryCode.CO,
    nid: detailTask?.nid,
    customFields: CUSTOM_FIELDS_FOR_SELLERS_CO,
  });

  const { data: leadDetail } = useGetLeadDetailInfoQuery({
    country: CountryCode.CO,
    nid: detailTask?.nid,
  });

  const { data: nidPriceAvailability } = useGetNidPriceAvailabilityQuery({
    nid: detailTask?.nid,
    country: CountryCode.CO,
  });

  const isMarketMaker = detailTask?.business_type === 'committee';

  const NO_VALUE = 'No tiene';
  const NO_DECLARATION = 'Falta declaración';
  const address = data?.direccion || NO_VALUE;
  const complexName = data?.nombre_del_conjunto || NO_VALUE;
  const tower = data?.torre || NO_VALUE;
  const apartment = data?.apartamento || NO_VALUE;
  const garage = data?.tipo_de_garaje || NO_VALUE;
  const numGarajes = data?.numero_parqueaderos || NO_VALUE;
  const calificacionLead = data?.calificacion_lead_remodelaciones || NO_VALUE;
  const minorChildren = data?.el_negocio_tiene_hijos_menores_ || NO_DECLARATION;

  useEffect(() => {
    if (leadDetail) {
      dispatch(setLeadDetailData(leadDetailDataCO(leadDetail, detailTask)));
    }
  }, [dispatch, leadDetail]);

  if (isFetching) return <div>Cargando información...</div>;

  return (
    <>
      <span>|</span>
      <div>Dirección: {address}</div>
      <span>|</span>
      <div>Conjunto: {complexName}</div>
      <span>|</span>
      <div>
        Torre: {tower}, Apartamento: {apartment}
      </div>
      <span>|</span>
      <div>Garaje: {garage}</div>
      <span>|</span>
      <div>Num. de garajes: {numGarajes}</div>
      <span>|</span>
      <div className="fw-bold text-decoration-underline">
        Calificación REMO: {calificacionLead}
      </div>
      <span>|</span>
      <div className="patrimony-pilot">
        <Badge className="badge-patrimony">Patrimonio de familia</Badge>
      </div>
      <span>|</span>
      <div className={minorChildren === NO_DECLARATION ? 'text-danger' : ''}>
        Hijos menores: {minorChildren}
      </div>
      {isMarketMaker && (nidPriceAvailability || leadDetail) && (
        <div className="lote-id-warning-pilot">
          {nidPriceAvailability && (
            <PriceAvailabilityBanner
              currentState={nidPriceAvailability.current_state}
              isAvailablePrice={nidPriceAvailability.is_available_price}
              inline
            />
          )}
          {leadDetail && (
            <LoteIdWarning
              loteId={leadDetail.location?.lote_id ?? null}
              inline
            />
          )}
        </div>
      )}
    </>
  );
};
